/* eslint-disable */
const sendBeacon = function (url, data) {
  var xhr =
    'XMLHttpRequest' in window
      ? new XMLHttpRequest()
      : new ActiveXObject('Microsoft.XMLHTTP');
  xhr.open('POST', url, false);
  xhr.withCredentials = false;
  xhr.setRequestHeader('Accept', '*/*');
  if (typeof data === 'string') {
    xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
    xhr.responseType = 'text/plain';
  } else if ({}.toString.call(data) === '[object Blob]') {
    if (data.type) {
      xhr.setRequestHeader('Content-Type', data.type);
    }
  }

  try {
    xhr.send(data);
  } catch (error) {}
  return true;
};

if (
  typeof navigator === 'object' &&
  typeof navigator.sendBeacon !== 'function'
) {
  // sendBeacon is not supported
  navigator.sendBeacon = sendBeacon;
}



// WEBPACK FOOTER //
// ./src/providers/sendbeacon-polyfill.js